var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recent-contacts-container",class:_vm.clazz},[_c('span',[_vm._t("user")],2),_c('span',{staticClass:"info"},[_c('label',[_vm._v(_vm._s(_vm.textPrincipal))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})]),_c('span',[_vm._t("action")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }